import { cn } from '@/lib/utils';
import * as React from 'react';

import CRLogo from '@/assets/CR.png';

import { LoginBackdrop } from './login/LoginBackdrop';
import { Mono } from './login/loginContent';

interface Props {
  children: React.ReactNode;
  subtitle?: string;
  wide?: boolean;
}

/**
 * Shared shell for the centered auth pages (signup, signup success, forgot and
 * reset password). Matches the login/landing aesthetic: forced-dark canvas,
 * the animated backdrop, a centered Crimson Raven lockup, and a single card.
 */
export default function AuthLayout({
  children,
  subtitle = 'Red-Team Copilot',
  wide = false
}: Props) {
  return (
    <div className="dark relative min-h-svh w-full overflow-hidden bg-background text-foreground">
      <LoginBackdrop watermark="right" />

      <div className="relative z-10 flex min-h-svh items-center justify-center px-6 py-10 sm:px-10">
        <div className={cn('w-full', wide ? 'max-w-lg' : 'max-w-md')}>
          <div className="mb-8 flex flex-col items-center gap-3 text-center">
            <span className="flex h-14 w-14 items-center justify-center overflow-hidden rounded-2xl border border-primary/25 bg-black shadow-lg shadow-primary/10">
              <img
                src={CRLogo}
                alt="Crimson Raven"
                className="h-full w-full object-cover"
                draggable={false}
              />
            </span>
            <div>
              <Mono className="text-[13px] font-semibold text-foreground">
                Crimson Raven
              </Mono>
              <div className="text-sm text-muted-foreground">{subtitle}</div>
            </div>
          </div>

          <div className="rounded-2xl border border-border/60 bg-card/70 p-8 shadow-2xl shadow-black/40 backdrop-blur-xl">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
